var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.resolvedComponent && _vm.isVisible
    ? _c(
        "div",
        {
          class: _vm.wrapperCssClass,
          style: _vm.wrapperStyle,
          attrs: {
            id: _vm.wrapperAnchorId,
            "data-block-type": _vm.block.type,
            "data-block-id": _vm.block.id,
            "data-testid": "site-block",
          },
        },
        [
          _vm.hasWrapperBgOverlay
            ? _c("div", { style: _vm.wrapperBgOverlayStyle })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              style: _vm.hasWrapperBgOverlay
                ? { position: "relative", zIndex: 1 }
                : undefined,
            },
            [
              _c(
                _vm.resolvedComponent,
                _vm._b({ tag: "component" }, "component", _vm.blockProps, false)
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }